/**
 * Post list
 */

import '../../js/vendor/polyfills/polyfill-window-url.js';
import '../../js/vendor/polyfills/polyfill-replace-with.js';
import '../../js/vendor/polyfills/polyfill-element-closest.js';

// Import extend function.
import Component from '../../js/core/component.js';
import ajax from '../../js/utilities/ajax/u-ajax.js';

class PostList extends Component {
	/**
	 * Default settings for this component
	 * @return {object} Default settings
	 */
	_defaultSettings () {
		return {
			debug: false
		};
	}

	/**
	 * Initialize component
	 */
	_init () {
		this.element = this.settings.element;
		if(!this.element) {
			return;
		}
		this.updateElement = this.element.getAttribute('data-update-target');
		this.autoUpdate = this.element.hasAttribute('data-auto-submit');

		if(this.updateElement) {
			this.updateElemTarget = this.element.closest('.c-post-list').querySelector('#' + this.updateElement);
			this.element.closest('.c-post-list').setAttribute('aria-live', 'polite');
			this.element.addEventListener('change', () => {
				this._updateContent();
			});
		}
		else if (this.autoUpdate) {
			this.element.addEventListener('change', () => {
				this._autoUpdate();
			});
		}
	}

	/**
	 * Update table
	 */
	_updateContent () {
		let formData = new FormData(this.element);
		const responseWrapper = document.createElement('div');

		ajax({
			method: this.element.getAttribute('method'),
			url: this.element.getAttribute('action'),
			data: formData,
			onSuccess: (response) => {
				responseWrapper.innerHTML = response;
				let updateElem = responseWrapper.querySelector('#' + this.updateElement);
				if(updateElem) {
					this.updateElemTarget.replaceWith(updateElem);
					this.updateElemTarget = this.element.closest('.c-post-list').querySelector('#' + this.updateElement);
					this.updateElemTarget.dispatchEvent(new CustomEvent('newcontent'));

					if (updateElem.getAttribute('data-update-url') && window.history && window.history.replaceState) {
						let uri = updateElem.getAttribute('data-update-url');
						let url = new URL(uri, document.location);
						window.history.replaceState('', '', url.toString());
					}
				}
			}
		});
	}

	_autoUpdate () {
		if (this.element.tagName === 'FORM') {
			this.element.submit();
		}
	}
}

document.addEventListener('newcontent', (e) => {
	e.target.querySelectorAll('.c-post-list__filter').forEach((postList) => {
		postList.postList = new PostList({
			element: postList
		});
	});
});

export default PostList;


// WEBPACK FOOTER //
// ./components/post-list/c-post-list.js